interface LanguageTranslation {
    de: string,
    en: string,
    fr: string
}

// tbo = translation by object
export const tbo = (language: string, translations: LanguageTranslation) => {
    switch (language) {
        case "en":
            return translations.en;
        case "de":
            return translations.de;
        case "fr":
            return translations.fr;
        default:
            console.error("failed to translate");
            return translations.en
    }
}

export const formLabelTranslations = {

    images: {
        de: "Bilder (maximal 3)",
        en: "Images (maximum 3)",
        fr: "Images (maximum 3)"
    },
    land: {
        de: "Land",
        en: "Country",
        fr: "Pays"
    },
    filialnummer: {
        de: "Filialnummer",
        en: "Branch number",
        fr: "Numéro de succursale"
    },
    filialname: {
        de: "Filialname",
        en: "Branch name",
        fr: "Nom de la succursale"
    },
    serialNumber: {
        de: "Seriennummer (von defektem Artikel)",
        en: "Serial number (from defective item)",
        fr: "Numéro de série (de l'article défectueux)"
    },
    trade: {
        de: "Gewerk:",
        en: "Trade:",
        fr: "Métier :"
    },
    producer: {
        de: "Hersteller",
        en: "Manufacturer",
        fr: "Fabricant"
    },
    defectDescription: {
        de: "Fehlerbeschreibung",
        en: "Defect description",
        fr: "Description du défaut"
    },
    erichterpaket: {
        de: "Erichterpaket vorhanden?",
        en: "Installation kit available?",
        fr: "Kit d'installation disponible?"
    },
    deliveryAddress: {
        de: "Adresse für Lieferung Austauschartikel",
        en: "Delivery address for replacement items",
        fr: "Adresse de livraison pour les articles de remplacement"
    },
    headingDeliveryAndPickUpAdressSame: {
        de: "Adresse für Abholung des defekten Artikels",
        en: "Address for pickup of the defective item",
        fr: "Adresse pour l’enlèvement de l’article défectueux"
    },
    deliveryAndPickUpAdressSame: {
        de: 'Adresse für Abholung des defekten Artikels abweichend von Lieferadresse?',
        en: 'Pickup address for the defective item different from the delivery address?',
        fr: 'Adresse de l’enlèvement de l’article défectueux différente de l’adresse de livraison ?'
    },
    addressCompanyName: {
        de: "Firmenname",
        en: "Company name",
        fr: "Nom de l'entreprise"
    },
    addressStreetNumber: {
        de: "Straße, Nummer",
        en: "Street, number",
        fr: "Rue, numéro"
    },
    addressPostalCode: {
        de: "Postleitzahl",
        en: "Postal code",
        fr: "Code postal"
    },
    addressCity: {
        de: "Ort",
        en: "City",
        fr: "Ville"
    },
    addressContactPerson: {
        de: "Ansprechpartner",
        en: "Contact person",
        fr: "Personne de contact"
    },
    addressPhone: {
        de: "Telefon",
        en: "Phone",
        fr: "Téléphone"
    },
    reason: {
        de: 'Grund für Rücksendung',
        en: 'Reason for return',
        fr: 'Raison du retour',
    },
    reasonHardwareError: {
        de: 'Hardwarefehler',
        en: 'Hardware failure',
        fr: 'Défaillance matérielle'
    },
    reasonSoftwareError: {
        de: 'Softwarefehler',
        en: 'Software error',
        fr: 'Erreur logicielle'
    },
    reasonVandalism: {
        de: 'Vandalismus',
        en: 'Vandalism',
        fr: 'Vandalisme'        
    },
    reasonWaterdamage: {
        de: 'Wasserschaden',
        en: 'Water damage',
        fr: 'Dégâts des eaux'        
    },
    reasonTransportdamage: {
        de: 'Transportschaden',
        en: 'Transport damage',
        fr: 'Dommage de transport'        
    },
    reasonOther: {
        de: 'Sonstiges',
        en: 'Other',
        fr: 'Autre'        
    },
    addressEmail: {
        de: "Email",
        en: "Email",
        fr: "Email"
    },
    formYes: {
        de: "Ja",
        en: "Yes",
        fr: "Oui"
    },
    formNo: {
        de: "Nein",
        en: "No",
        fr: "Non"
    },
    formHeading: {
        de: "RMA Formular",
        en: "RMA Form",
        fr: "Formulaire RMA"
    },
    formPleaseChoose: {
        de: "Bitte wählen ...",
        en: "Please Choose ...",
        fr: "Veuillez choisir ..."
    },
    formSend: {
        de: "Abschicken",
        en: "Send",
        fr: "Envoyer"
    },
    formDelete: {
        de: "Formulardaten löschen",
        en: "Delete form data",
        fr: "Supprimer les données du formulaire"
    },
    formDeleteMessage: {
        de: "Möchten Sie die Daten des Formulars wirklich löschen?",
        en: "Do you really want to delete the form data?",
        fr: "Voulez-vous vraiment supprimer les données du formulaire ?"
    },
    landGermany: {
        de: 'Deutschland',
        en: 'Germany',
        fr: 'Allemagne'
    },    
    landFrench: {
        de: 'Frankreich',
        en: 'France',
        fr: 'France'
    },
    seriennummerErrichterpaket: {
        de: 'Seriennummer aus Errichterpaket',
        en: 'Serial number from installer package',
        fr: 'Numéro de série du kit d’installateur'
    },
    category: {
        de: "Kategorie",
        en: "Category",
        fr: "Catégorie"
    }
}

export const formErrors = {
    defectDescriptionAtLeast20Chars: {
        de: 'Fehlerbeschreibung muss mindestens 20 Zeichen lang sein.',
        en: 'Error description must be at least 20 characters long.',
        fr: 'La description de l’erreur doit comporter au moins 20 caractères.'
    },
    invalidEmail: {
        de: "Ungültige E-Mail-Adresse",
        en: "Invalid email address",
        fr: "Adresse e-mail invalide"
    },
    requiredField: {
        de: "Dieses Feld ist benötig.",
        en: "This field is Required.",
        fr: "Ce champ est obligatoire."
    },
    serialNumberErrichterPaket: {
        de: 'Gib bitte die Seriennummer aus dem Errichterpaket an.',
        en: 'Please enter the serial number from the installer package.',
        fr: 'Veuillez saisir le numéro de série du paquet installateur.'
    },
}